// @ts-nocheck

import { createSelector } from 'reselect';

import { type BetslipState } from '../states/entities/betslips';
import { type BetslipStatusType } from '../types/history';
import { type SelectorMaker } from '../types/selectors';

import { getBetslipIdFromProps, getBetslipReferenceFromProps } from './_propsGetters_';
import { selectEntitiesBetslips } from './entities/betslips/entitiesBetslipsPrimary.selector';

export const makeEntitiesBetslipsEntityStateByBetslipRefSelector: SelectorMaker<BetslipState | undefined> = () =>
  createSelector([selectEntitiesBetslips, getBetslipReferenceFromProps], (betslips, betslipReference) => {
    const betslipIds = Object.keys(betslips);

    return betslips[
      betslipIds.find((betslipId) => !!~(betslips[betslipId].betslipReference?.indexOf(betslipReference) ?? -1))
    ];
  });

export const makeEntitiesBetslipEntityStateByBetslipIdSelector: SelectorMaker<BetslipState | undefined> = () =>
  createSelector([selectEntitiesBetslips, getBetslipIdFromProps], (betslips, betslipId) => {
    return betslips[betslipId];
  });

export const makeEntitiesBetslipEntityBetslipReferenceByBetslipIdSelector: SelectorMaker<string | undefined> = () =>
  createSelector([makeEntitiesBetslipEntityStateByBetslipIdSelector()], (betslip) => betslip?.betslipReference);

export const makeEntitiesBetslipsEntityBetAmountByBetslipRefSelector: SelectorMaker<number | undefined> = () =>
  createSelector([makeEntitiesBetslipsEntityStateByBetslipRefSelector()], (betslip) => betslip?.betAmount);

export const makeEntitiesBetslipsEntityPossibleWinningsByBetslipRefSelector: SelectorMaker<
  number | null | undefined
> = () =>
  createSelector([makeEntitiesBetslipsEntityStateByBetslipRefSelector()], (betslip) => betslip?.possibleWinnings);

export const makeEntitiesBetslipsEntityPossibleBonusByBetslipRefSelector: SelectorMaker<
  number | null | undefined
> = () => createSelector([makeEntitiesBetslipsEntityStateByBetslipRefSelector()], (betslip) => betslip?.possibleBonus);

export const makeEntitiesBetslipsEntityWinningAmountByBetslipRefSelector: SelectorMaker<
  number | null | undefined
> = () => createSelector([makeEntitiesBetslipsEntityStateByBetslipRefSelector()], (betslip) => betslip?.winningsAmount);

export const makeEntitiesBetslipsEntityWinningBonusByBetslipRefSelector: SelectorMaker<
  number | null | undefined
> = () => createSelector([makeEntitiesBetslipsEntityStateByBetslipRefSelector()], (betslip) => betslip?.winningsBonus);

export const makeEntitiesBetslipsEntityStatusByBetslipRefSelector: SelectorMaker<BetslipStatusType | undefined> = () =>
  createSelector([makeEntitiesBetslipsEntityStateByBetslipRefSelector()], (betslip) => betslip?.status);

export const makeEntitiesBetslipsEntityDetailsByBetslipRefSelector: SelectorMaker<
  | Array<{
      outcomeId: number;
      odds: number;
    }>
  | undefined
> = () => createSelector([makeEntitiesBetslipsEntityStateByBetslipRefSelector()], (betslip) => betslip?.details);
